import {
  SelectMediaConfig,
  SelectMediaConfigButton,
  SelectMediaConfigEmptyState,
} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaConfig';
import {SelectMediaContextProvider} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaContextProvider';
import type {OnSelectVideo} from '@cohort/merchants/apps/tiktok/triggers/components/SelectVideoSheet';
import SelectVideoSheet from '@cohort/merchants/apps/tiktok/triggers/components/SelectVideoSheet';
import TikTokVideoCard from '@cohort/merchants/apps/tiktok/triggers/components/TikTokVideoCard';
import type {TikTokVideo} from '@cohort/shared/apps/tiktok/common';
import {Fragment} from 'react/jsx-runtime';

type TikTokVideoSelectorProps = {
  description: string;
  onSelectVideo: OnSelectVideo;
  title: string;
  videos: TikTokVideo[];
  selectedVideo?: TikTokVideo;
};

const TikTokVideoSelector: React.FC<TikTokVideoSelectorProps> = ({
  description,
  onSelectVideo,
  selectedVideo,
  title,
  videos,
}) => (
  <SelectMediaContextProvider defaultMediaId={selectedVideo?.id ?? null}>
    <SelectMediaConfig title={title} description={description}>
      {selectedVideo === undefined ? (
        <Fragment>
          <SelectMediaConfigEmptyState />
          <SelectMediaConfigButton mode="add" />
        </Fragment>
      ) : (
        <Fragment>
          <TikTokVideoCard media={selectedVideo} />
          <SelectMediaConfigButton mode="change" />
        </Fragment>
      )}
      <SelectVideoSheet onSelectVideo={onSelectVideo} videos={videos} />
    </SelectMediaConfig>
  </SelectMediaContextProvider>
);

export default TikTokVideoSelector;
